import {
  borderRadius,
  color,
  fontSize,
  fontWeight,
  padding,
  shadow,
} from '@evrekadev/evreka-ui-components'
import { Button } from 'components'
import styled, { css } from 'styled-components'

export const MapStyled = styled.div<{ border?: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${({ border }) =>
    border &&
    css`
      ${borderRadius(12)}
      border: 1px solid ${color('grey200')};
    `}

  .leaflet-container {
    flex-grow: 1;
  }

  .button-container .leaflet-pm-actions-container .leaflet-pm-action {
    display: none;
  }

  .leaflet-control-zoom {
    ${shadow('xs')}
    ${borderRadius(4)}
    ${padding([2])}
    border: none;
    background-color: ${color('white')};
  }
  .leaflet-control-zoom-in,
  .leaflet-control-zoom-out {
    font-family: 'Open-Sans';
    ${fontSize('text_sm')};
    ${fontWeight('bold')}
    color: ${color('darkblue500')};
    &.leaflet-disabled {
      color: ${color('grey300')};
      :hover {
        color: ${color('grey300')};
      }
    }
    :hover {
      color: ${color('darkblue900')};
    }
  }

  .leaflet-tooltip {
    ${fontSize('text_xs')};
    padding: 3px;
    word-wrap: break-word;
  }

  .leaflet-popup-content-wrapper {
    padding: 1.5rem 2rem;
  }

  .leaflet-popup-tip-container {
    margin-left: -20px;
  }

  .leaflet-container a.leaflet-popup-close-button {
    padding: 4px 0 0 0;
    height: 2rem;
    width: 2rem;
  }

  // hide leaflet
  .leaflet-control-attribution {
    display: none;
  }
  .leaflet-control-layers {
    ${borderRadius(8)}
    ${fontSize('text_xs')}
    ${fontWeight('regular')}
    line-height: 1rem;
    font-style: normal;
    margin-bottom: 1.5rem;
  }

  .leaflet-control-layers-expanded {
    padding: 0.5rem;
  }

  .leaflet-div-icon {
    border: none !important;
    background: none !important;
  }
`

// .leaflet-pm-toolbar {
//   ${fontSize('text_sm')};

//   .leaflet-pm-icon-rectangle {
//     background-image: url(${rectangle});
//   }

//   .leaflet-pm-icon-polygon {
//     background-image: url(${polygon});
//   }

//   .leaflet-pm-icon-circle {
//     background-image: url(${circle});
//   }

//   .leaflet-pm-icon-edit {
//     background-image: url(${edit});
//   }

//   .leaflet-pm-icon-drag {
//     background-image: url(${move});
//   }

//   .leaflet-pm-icon-delete {
//     background-image: url(${erase});
//   }

//   .leaflet-pm-icon-rotate {
//     background-image: url(${rotate});
//   }
// }

// .leaflet-control-layers-toggle {
//   background-image: url(${mapLayers});
// }

export const MapControlButton = styled(Button)<{ top?: number }>`
  position: absolute;
  z-index: 1000;
  top: ${({ top }) => (top ? `${top}px` : '128px')};
  left: 10px;
`
